import React from 'react';
import { generatePath, useHistory, useParams } from 'react-router';

import { NavButton } from 'src/shared/components/NavButton';
import { FeatureFlag } from 'src/shared/constants';
import { useReactNativeWebView, useTreatment } from 'src/shared/hooks';
import { External, Route } from 'src/shared/route';
import { backButtonPressed } from 'src/shared/telemetry';
import { isEnabled } from 'src/shared/telemetry/featureFlag';

import { Component as Back } from 'assets/icons/ui/back.svg';

const BackButton = () => {
  const shouldNavigateToWebReact = isEnabled(
    useTreatment(FeatureFlag.Web.PROPERTY_DETAILS),
  );
  const [isWebView, sendReactNativeMessage] = useReactNativeWebView();
  const history = useHistory();
  const { jobId } = useParams<{ jobId: string }>();

  const handleBackClick = () => {
    if (isWebView) {
      sendReactNativeMessage('handleNativeBack');
    } else if (shouldNavigateToWebReact) {
      history.push(
        generatePath(Route.PROPERTY_DETAILS.path, {
          jobId,
        }),
      );
    } else {
      window.location.href = generatePath(External.PROPERTY_DETAILS.path, {
        jobId,
      });
    }
  };

  return (
    <NavButton
      icon={Back}
      onClick={handleBackClick}
      testId="back-button"
      track={backButtonPressed}
    />
  );
};

export { BackButton };
